<div
  class="visual_aid_enabled"
  [class.no-hint]="!callStore.getHints()"
  [class.is-ipad]="callStore.getIsIpad()"
  [class.visual-aid-closed]="!callStore.getIsVisualAidOpen() || animation"
  [class.animation]="animation"
  [class.fullscreen]="callStore.getIsFullScreen()">
  <div class="inner">
    <div class="avatar">
      <ng-content select="[avatarSlot]" />
    </div>
    <div class="hint">
      <ng-content select="[hintSlot]" />
    </div>
    <div class="visual_aid">
      <app-visual-guide
        [controlService]="controlService"
        [playerService]="playerService"
      ></app-visual-guide>
    </div>
  </div>
</div>
